import React from 'react';
import '../styles/Cutch.css';

const productSpecs = [
  { label: 'Product Name', value: 'Cutch/Catechu - Cutch (Powder & Block) / Indian Katha' },
  { label: 'Product Composition', value: 'Concentrated extract made from heartwood chips of Khair tree (Acacia catechu), obtained by boiling in water and evaporation. Contains natural tannins, catechins, flavonoids, and bioactive phenolic compounds.' },
  { label: 'Dangerous Ingredients', value: 'None' },
  { label: 'Available in', value: '5 mm square batti packed in 1 kg boxes, in 20 kg carton' },
];

const industrialUses = [
  'Primary commercial product derived from Khair (Acacia catechu) heartwood, along with Cutch',
  'Essential ingredient in traditional Indian herbal preparations and flavoured mouth fresheners since ancient times',
  'Traditionally used as a natural mouth freshener across India',
  'Widely used in confectionery and mouth-freshener applications along with natural flavouring ingredients',
  'Used as a natural astringent and binding agent in food and Ayurvedic formulations',
];

const medicalUses = [
  'Decoctions of the bark and heartwood are used for sore throats, cold, and cough in Ayurveda (bark decoction with milk taken for two weeks)',
  'Small piece of Catechu can stop bleeding gums and heal canker sores — applied directly to mouth',
  'Natural flavouring and confectionery ingredient with astringent properties',
  'Treats diarrhea and dysentery — bark decoction used alone or with other preparations',
  'Treats ailments of mouth, gums, and tonsils — bark placed in cavity for toothache relief',
  'Anti-inflammatory — significantly inhibits inflammation and foot paw edema',
];

function Cutch() {
  return (
    <div className="cutch-page">

      {/* Banner Image */}
      <div className="cutch-banner">
        <img src="/cll.png" alt="Cutch / Catechu Banner" className="cutch-banner-img" />
      </div>

      {/* Main Content */}
      <div className="cutch-container">
        <div className="cutch-left">

          <h2 className="cutch-title">
            Cutch/Catechu (Cutch Powder &amp; Block)
          </h2>

          <p className="cutch-desc">
            <strong>Cutch/Catechu (Cutch Powder &amp; Block)</strong> or{' '}
            <strong>Katha Powder</strong>, also known as Katha or Katha Powder, is a natural extract
            derived from the heartwood of the Acacia catechu (Khair) tree — a medium-sized, thorny
            deciduous tree of the family Fabaceae that grows up to 13 metres in height, native to
            South Asia and Southeast Asia including India, Myanmar, Thailand, and China (Yunnan).
            The extract is obtained by boiling the heartwood chips in water and evaporating the
            resulting brew into a concentrated solid or powder form. It is one of the most versatile
            natural tannins in the world and is commercially known by many names: Cutch, Black Cutch,
            Cachou, Cashoo, Khoyer, Terra Japonica, Japan Earth, and also as Katha (Hindi), Kaath
            (Marathi), Khoyer (Assamese and Bengali), and Kachu (Malay).
          </p>

          <p className="cutch-desc">
            Acacia Catechu is called Khadira in Sanskrit, Karingali in Malayalam, and Khair / Katha /
            Khadir in Bengali. As an astringent, it has been used since ancient times in Ayurvedic
            medicine, in breath-freshening spice mixtures, and as a natural flavouring and confectionery
            ingredient in traditional Indian herbal preparations including chewable herbal preparations
            and flavoured mouth fresheners.
          </p>

        

          <h3 className="cutch-subtitle">Product Identification &amp; Specifications:</h3>
          <table className="cutch-table">
            <tbody>
              {productSpecs.map((s, i) => (
                <tr key={i}>
                  <td className="spec-label">{s.label}</td>
                  <td className="spec-value">{s.value}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3 className="cutch-subtitle">Industrial Use:</h3>
          <ul className="cutch-uses">
            {industrialUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

          <h3 className="cutch-subtitle">Medical Use:</h3>
          <ul className="cutch-uses">
            {medicalUses.map((u, i) => (
              <li key={i}>{u}</li>
            ))}
          </ul>

        </div>
      </div>
    </div>
  );
}

export default Cutch;